import type { Tags } from "../../../merge-tag/types";

export function searchTags(tags: Tags, searchText: string | null): Tags {
  if (searchText === null) return [];

  const query = searchText.toLowerCase().replaceAll("_", "");

  const startsWith = tags.filter((t) => t.id.replaceAll("_", "").startsWith(query));
  const matches = tags.filter(
    (t) => !startsWith.includes(t) && t.id.replaceAll("_", "").includes(query),
  );

  return [...startsWith, ...matches];
}
